import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";

const LivePulseDashboard = () => {
  const [metrics, setMetrics] = useState({
    visitorsToday: 247,
    activeThreats: 2,
    speciesMonitored: 823,
    conservationScore: 94
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setMetrics((prev) => ({
        visitorsToday: prev?.visitorsToday + Math.floor(Math.random() * 3),
        activeThreats: Math.max(0, prev?.activeThreats + (Math.random() > 0.7 ? 1 : -1)),
        speciesMonitored: prev?.speciesMonitored + (Math.random() > 0.5 ? 1 : 0),
        conservationScore: Math.min(100, Math.max(85, prev?.conservationScore + (Math.random() - 0.5) * 2))
      }));
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const dashboardCards = [
    {
      id: 1,
      icon: "Users",
      label: "Visitors Today",
      value: metrics?.visitorsToday,
      trend: "+12%",
      color: "var(--color-primary)",
      bgColor: "var(--color-primary)/10"
    },
    {
      id: 2,
      icon: "AlertTriangle",
      label: "Active Threats",
      value: metrics?.activeThreats,
      trend: "Low",
      color: metrics?.activeThreats > 3 ? "var(--color-error)" : "var(--color-success)",
      bgColor: metrics?.activeThreats > 3 ? "var(--color-error)/10" : "var(--color-success)/10"
    },
    {
      id: 3,
      icon: "Leaf",
      label: "Species Monitored",
      value: metrics?.speciesMonitored,
      trend: "+3 today",
      color: "var(--color-secondary)",
      bgColor: "var(--color-secondary)/10"
    },
    {
      id: 4,
      icon: "Shield",
      label: "Conservation Score",
      value: `${Math.round(metrics?.conservationScore)}%`,
      trend: "Excellent",
      color: "var(--color-accent)",
      bgColor: "var(--color-accent)/10"
    }
  ];

  return (
    <section className="py-16 bg-[var(--color-background)]">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-[var(--color-primary)]/10 rounded-full px-4 py-2 mb-4">
            <div className="w-2 h-2 bg-[var(--color-success)] rounded-full pulse-conservation"></div>
            <span className="text-[var(--color-primary)] text-sm font-medium">
              Live Conservation Metrics
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[var(--color-foreground)] mb-4">
            Real-Time Park Status
          </h2>
          <p className="text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
            Monitor live conservation activities, visitor statistics, and ecosystem health indicators updated every 5 seconds
          </p>
        </div>

        {/* Dashboard Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {dashboardCards?.map((card) => (
            <div
              key={card?.id}
              className="bg-[var(--color-card)] rounded-lg p-6 border border-[var(--color-border)] hover:shadow-conservation-lg transition-all animation-organic"
            >
              <div className="flex items-start justify-between mb-4">
                <div
                  className="p-3 rounded-lg"
                  style={{ backgroundColor: card?.bgColor }}
                >
                  <Icon name={card?.icon} size={24} color={card?.color} />
                </div>
                <span
                  className="text-xs font-medium px-2 py-1 rounded-full"
                  style={{
                    color: card?.color,
                    backgroundColor: card?.bgColor
                  }}
                >
                  {card?.trend}
                </span>
              </div>
              <div className="text-3xl font-bold text-[var(--color-foreground)] mb-1">
                {card?.value}
              </div>
              <div className="text-sm text-[var(--color-muted-foreground)]">
                {card?.label}
              </div>
            </div>
          ))}
        </div>

        {/* Last Updated */}
        <div className="text-center mt-8">
          <p className="text-sm text-[var(--color-muted-foreground)]">
            Last updated: {new Date()?.toLocaleTimeString()} • Data refreshes every 5 seconds
          </p>
        </div>
      </div>
    </section>
  );
};

export default LivePulseDashboard;